module.exports = "/assets/data/c67f3ae7683a2c23feb3b12043311225-TS27.data.json";